<script>
    import I18n from '@js/modules/translations';

    import TimeSwitcher from '@js/components/themes/TimeSwitcher.svelte';

    import('@css/components/time-picker.scss');

    const {
        class: className,
        label,
        initialTime = '00:00:00',
        currentTime,
        onTimeChange
    } = $props();

    const HOURS = new Array(24).fill(0)
        .map((v, i) => v + i);
    const MINUTES = new Array(60).fill(0)
        .map((v, i) => v + i);
    const SECONDS = new Array(60).fill(0)
        .map((v, i) => v + i);

    const convertChronoTime = (chronoTime) => {
        const dateTime = new Date();

        if (typeof chronoTime === 'string') {
            const [
                hour,
                minute,
                second
            ] = chronoTime.split(':');

            dateTime.setHours(parseInt(hour), parseInt(minute), parseInt(second));
        } else {
            dateTime.setHours(0, 0, 0);
        }

        return dateTime;
    };

    const dateToDuration = (currentDate) => {
        return currentDate.getHours() * 3600 + currentDate.getMinutes() * 60 + currentDate.getSeconds();
    };

    let date = $state(convertChronoTime(initialTime));

    const _handleTimeChange = (type, changedData) => {
        let newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());

        switch (type) {
            case 'hour':
                newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), changedData, date.getMinutes(), date.getSeconds());
                break;
            case 'minute':
                newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), changedData, date.getSeconds());
                break;
            case 'second':
                newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), changedData);
                break;
        }

        date = newDate;

        onTimeChange(dateToDuration(date), date.toLocaleTimeString('us-EN'));
    };

    $effect(() => {
        date = convertChronoTime(currentTime || initialTime);
    });
</script>

<div class={className}>
    <div class="touch-date-wrapper">
        <div class="block self-start mb-2 text-sm font-medium text-gray-500 dark:text-white">
            {label}
        </div>

        <div class="touch-date-picker">
            <TimeSwitcher type="hour"
                          unitName={I18n.t('js.time.short_units.hour')}
                          data={HOURS}
                          selected={date.getHours() + 1}
                          onUnitChange={_handleTimeChange}/>
            <TimeSwitcher type="minute"
                          unitName={I18n.t('js.time.short_units.minute')}
                          data={MINUTES}
                          selected={date.getMinutes() + 1}
                          onUnitChange={_handleTimeChange}/>
            <TimeSwitcher type="second"
                          unitName={I18n.t('js.time.short_units.second')}
                          data={SECONDS}
                          selected={date.getSeconds() + 1}
                          onUnitChange={_handleTimeChange}/>
        </div>
    </div>
</div>
